import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import RemoveControl from './remove_control';
import { mapId, mapName } from 'helpers/react_select_helpers';

import { connect } from 'react-redux';
import { removeAssignee, setAssigneeRole, setAssigneeUser } from './store/workflow/actions';

export const roleType = {
  label: 'Role',
  value: 'role'
};

export const userType = {
  label: 'User',
  value: 'user'
};

export class TaskWorkflowAssignee extends React.Component {
  static propTypes = {
    assignee: PropTypes.shape({
      role: PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      }),
      user: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired
      })
    }).isRequired,
    assigneeGroup: PropTypes.object.isRequired,
    removeAssignee: PropTypes.func.isRequired,
    roles: PropTypes.array.isRequired,
    setAssigneeRole: PropTypes.func.isRequired,
    setAssigneeUser: PropTypes.func.isRequired,
    step: PropTypes.object.isRequired,
    users: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired
  }

  // Just for locally persisting role/user when switching types back and forth
  state = {
    role: this.props.assignee.role,
    type: this.props.assignee.role ? roleType : userType,
    user: this.props.assignee.user
  }

  handleTypeChange = (type) => {
    if (!type) {
      return;
    }

    this.setState({ type });

    if (type === roleType) {
      const role = this.state.role || null;
      this.props.setAssigneeRole(this.props.step, this.props.assigneeGroup, this.props.assignee, role);
    } else {
      const user = this.state.user || null;
      this.props.setAssigneeUser(this.props.step, this.props.assigneeGroup, this.props.assignee, user);
    }
  }

  handleRoleChange = (role) => {
    this.setState({ role });
    this.props.setAssigneeRole(this.props.step, this.props.assigneeGroup, this.props.assignee, role);
  }

  handleUserChange = (user) => {
    this.setState({ user });
    this.props.setAssigneeUser(this.props.step, this.props.assigneeGroup, this.props.assignee, user);
  }

  removeAssignee = () => {
    this.props.removeAssignee(this.props.step, this.props.assigneeGroup, this.props.assignee);
  }

  render() {
    return (
      <div className="task-workflow-assignee">
        <Select
          className="select assignee-type-select"
          classNamePrefix={null}
          isClearable
          name="type"
          options={[userType, roleType]}
          value={this.state.type}
          onChange={this.handleTypeChange}
        />

        {this.state.type === userType ? this.renderUserSelect() : this.renderRoleSelect()}

        <RemoveControl onClick={this.removeAssignee} />
      </div>
    );
  }

  renderRoleSelect() {
    return (
      <Select
        className="select assignee-select"
        classNamePrefix={null}
        name="role"
        options={this.props.roles}
        placeholder="Select role"
        value={this.props.assignee.role}
        onChange={this.handleRoleChange}
      />
    );
  }

  renderUserSelect() {
    return (
      <Select
        className="select assignee-select"
        classNamePrefix={null}
        getOptionLabel={mapName}
        getOptionValue={mapId}
        name="user"
        options={this.props.users}
        placeholder="Select user"
        value={this.props.assignee.user}
        onChange={this.handleUserChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  roles: state.static.roles,
  users: state.static.users
});

const mapDispatchToProps = {
  removeAssignee,
  setAssigneeRole,
  setAssigneeUser
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskWorkflowAssignee);
